export default {
  CHAT_BOT: 'Chat Bot',
  SELECT: 'Select',
  LOGIN: 'Login',
  YOU: '(You)',
  LOGOUT: 'Logout'
}